//@flow
import React from 'react'
import injectSheet from 'react-jss'
import SVG from 'react-svg-inline'
import caretDown from '../images/caret-down.svg';
import { Tooltip, Typography, theme } from '@hiver/hiver-ui-kit';

class HiverSelect extends React.Component<State, Props> {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            current: props.current && props.current > -1 ? props.current : 0,
            left: 0,
            top: 0
        };

        this.ref = React.createRef()
    }

    componentDidUpdate(prevProps, prevState) {
        const { onSelect, options } = this.props;
        if (
            prevState.current !== this.state.current && 
            this.props.current !== this.state.current
        ) {
            typeof onSelect === 'function' && onSelect(options[this.state.current]);
        }
        if (prevProps.current !== this.props.current && 
            this.props.current !== this.state.current
        ) {
            this.setState({ current: this.props.current })
        }
    }

    componentDidMount() {
        if (typeof this.props.getResetCurrent ===  'function') {
            this.props.getResetCurrent(this.setCurrentFromProp)
        }
    }

    setCurrentFromProp = () => {
        this.setState({
            current: this.props.current
        })
    }

    handleSelect = (idx) => {    
        this.setState({ current: idx, open: false }, this.handlePropsUpdate);
    }

    handleClickOutside = () =>  {
        this.setState({ open: false }, this.handlePropsUpdate);
    } 

    toggleOpen = () => {
        const { current } = this.ref
    
        const { top, left, height } = current.getBoundingClientRect()
        this.setState(state => ({
            ...state,
            open: !state.open,
            top: top + height,
            left
        }), this.handlePropsUpdate)
    }

    handlePropsUpdate = () => {
        const { onMenuClose, onMenuOpen } = this.props
        const targetFn = this.state.open ? onMenuOpen : onMenuClose
        typeof targetFn === 'function' && targetFn(this.state.open)
    }

    renderOptions() {
        const { options, classes } = this.props;
        return options.map((option, idx) => 
            <div key={idx} className={classes.menuItem} onClick={() => this.handleSelect(idx)}>
                <div className="label">
                    <Typography variant="body2" 
                    sx={{
                    color: theme.palette.gray.black}}
                    >
                        {option.label}
                    </Typography>
                </div>
                { option.sublabel && <div className="sublabel">{option.sublabel}</div> }
            </div>
        )
    }

    renderSelected() {
        const { classes, options, width } = this.props;
        const { current } = this.state;
        const currentlySelected = options[current];
        return <React.Fragment>
            <div className={classes.selectLabel}>
                <div className="label">
                    <Tooltip title={currentlySelected.label} placement="bottom" arrow>
                    <Typography variant="body2" sx={{
                    color: theme.palette.gray.black,
                    textOverflow: 'ellipsis',
                    overflowX: 'hidden',
                    width: `${width-30}px`
                }}>{ currentlySelected.label }</Typography>
                </Tooltip>
                </div>
                <div className="sublabel">{ currentlySelected.sublabel }</div>
            </div>
            <div className={classes.caret}>
                <SVG svg={caretDown} />
            </div>
        </React.Fragment>
    }

    render() {
        const { classes, parentExists } = this.props;
        const { open, top, left } = this.state;
        const menuClass = open ? `${classes.selectMenu} active`: classes.selectMenu;
        const anchorBottom =  window.innerHeight - top < 200
        const style = parentExists ? anchorBottom ? { bottom: window.innerHeight - top, left } : { top, left } : {};
        return <div className={classes.root} tabIndex="0" 
            onBlur={this.handleClickOutside}
            ref={this.ref}>
            <div className={classes.select} onClick={this.toggleOpen}>
                { this.renderSelected() }
            </div>
            <div className={menuClass} style={style}>
                { this.renderOptions() }
            </div>
        </div>
    }
}

const styles = {
    root: {
        fontWeight: 'normal',
        position: props => props.parentExists ? 'initial': 'relative',
        width: props => props.width || 'initial',
        '&:focus': {
            outline: 'none'
        }
    },
    select: {
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    selectLabel: {
        color: '#303f48',
        '& .label': {
            fontSize: props => props.lite ? 14 : 19,
            marginBottom: props => props.lite ? 0 : 4,
        },
        '& .sublabel': {
            fontSize:  props => props.lite ? 10 : 13,
            color: 'rgba(27, 27, 27, 0.48)'
        }
    },
    caret: {
        marginLeft: 8,
        marginTop: 3,
        '& .SVGInline-svg': {
            height: 8,
            width: 8
        }
    },
    selectMenu: {
        minWidth: props => props.width || 200,
        position: props => props.parentExists ? 'fixed' : 'absolute',
        padding: props => props.lite ? '0': '10px 14px',
        backgroundColor: "#fff",
        zIndex: 1000,
        display: 'none',
        boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.19)',
        '&.active':{
            display: 'block'
        }
    },
    menuItem: {
        color: '#1b1b1b',
        cursor: 'pointer',
        height: props => props.lite ? 'auto' : 32,
        backgroundColor: '#fff',
        borderBottom: props => props.lite ? 'none' : 'solid 1px rgba(224,231,238,.45)',
        padding: props => props.lite ? '10px 14px': '10px 6px',
        '&:last-of-type': {
            borderBottom: 'none'
        },
        '& .label': {
            fontSize: 14,
            marginBottom: 4,
            letterSpacing: '0.5px',
            color: 'rgba(27, 27, 27, 0.8)',
            textAlign: props => props.lite ? 'start': 'initial'
        },
        '& .sublabel': {
            fontSize: 12,
            color: 'rgba(27, 27, 27, 0.48)'
        },
        '&:hover': {
            backgroundColor: 'rgba(224,231,238,.45)',
        }
    }
    
}
type State = {
    open: boolean,
    current: number
}

type OptionType = {
    label: string,
    sublabel: string
}

type Props = {
    options: Array<OptionType>,
    onSelect: Function,
    classes: Object,
    onMenuOpen: Function,
    onMenuClose: Function
}
export default injectSheet(styles)(HiverSelect);